import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'
import api from '@/constant/END_POINT'

export interface ClaimDocumentDownloadParams {
  claimId: string
  documentTypeId?: string
  claimDocumentId?: string
}

// ใช้ Blob แทน ClaimDocumentDownloadResponse
type DownloadResult = {
  blob: Blob
  filename: string
  contentType: string
}

export const fetchClaimDocumentDownload = async ({
  claimId,
  documentTypeId,
  claimDocumentId,
}: ClaimDocumentDownloadParams): Promise<DownloadResult> => {
  const params: Record<string, string> = {}
  if (documentTypeId) params.documentTypeId = documentTypeId
  if (claimDocumentId) params.claimDocumentId = claimDocumentId

  const response = await httpClientPrivate.get<Blob>(
    api.backoffice.downloadDocument(claimId),
    { params, responseType: 'blob' }, // สำคัญ
  )

  const contentType = response.headers['content-type'] || 'application/octet-stream'
  const filename = 'download.zip'

  // ถ้า BE ส่ง error JSON กลับมาเป็น blob ให้โยน error แทน
  if (contentType.includes('application/json')) {
    const text = await response.data.text()
    try {
      const err = JSON.parse(text)
      throw new Error(err?.message || 'Download failed')
    } catch {
      throw new Error(text || 'Download failed')
    }
  }

  return { blob: response.data, filename, contentType }
}

// ใช้ mutation สำหรับ action ดาวน์โหลด
export const useClaimDocumentDownload = () =>
  useMutation({
    mutationFn: fetchClaimDocumentDownload,
  })
